import "./Design.css";
import Header from "../../components/Header";
import { Parallax } from "react-scroll-parallax";
import image1 from "../../assets/image1.jpg";
import image2 from "../../assets/image2.jpg";
import image3 from "../../assets/image3.jpg";
import image4 from "../../assets/image4.jpg";
import image5 from "../../assets/image5.jpg";
import image6 from "../../assets/image6.jpg";
import image7 from "../../assets/image7.jpg";
import image8 from "../../assets/image8.png";
import image9 from "../../assets/image9.jpg";
import image10 from "../../assets/image10.jpg";
import image11 from "../../assets/image11.jpg";
import Footer from "../../components/Footer";

function Design() {
  function notification() {
    new Notification("Harry Azamosa Portfolio", {
      body: `The curriculum vitae of Harry Azamosa Osawayemen has been downloaded to your local device storage`,
    });
  }

  return (
    <div className="design">
      <Header />
      <div className="design_head">
        <div>
          <h1>Unparalleled </h1>
          <h1>Design and Dexterity.</h1>
        </div>
      </div>
      <div className="design_main">
        <h3>
          Here's my small home to distinguished projects I have worked on
          recenty, deeply rooted in my passion for helping brands express their
          desires cut accross UI/UX, graphics design and animation. I create
          brand identities through graphic design and art direction for brands,
          founders, start-ups, and institutions. True to my tradition, each of
          my brands builds on a specialty legacy while keeping an unwavering
          focus on the exquisite caliber of its projects.
        </h3>
      </div>
      <section className="design_section_one">
        <div className="design_div">
          <div>
            <img src={image10} className="design_image" />
            <div>
              <h3>The optimist</h3>
              <p>Brand Identity</p>
            </div>
          </div>
          <div>
            <img src={image9} className="design_image" />
            <div>
              <h3>Saturn V</h3>
              <p>Packaging design</p>
            </div>
          </div>
          <div>
            <img src={image2} className="design_image" />
            <div>
              <h3>La Presa</h3>
              <p>Book cover</p>
            </div>
          </div>
          <div>
            <img src={image3} className="design_image" />
            <div>
              <h3>Gossamer</h3>
              <p>Brand Identity</p>
            </div>
          </div>
          <div>
            <img src={image4} className="design_image" />
            <div>
              <h3>Gossamer</h3>
              <p>Brand Identity</p>
            </div>
          </div>
          <div>
            <img src={image5} className="design_image" />
            <div>
              <h3>Selan homes</h3>
              <p>Art direction</p>
            </div>
          </div>
          <div>
            <img src={image6} className="design_image" />
            <div>
              <h3>Gluck Selig</h3>
              <p>Book cover</p>
            </div>
          </div>
          <div>
            <img src={image7} className="design_image" />
            <h3>Gossamer</h3>
            <p>Brand Identity</p>
          </div>
          <div>
            <img src={image8} className="design_image" />
            <div>
              <h3>Foundational face Mist</h3>
              <p>Brand Identity, Packaging design</p>
            </div>
          </div>
          <div>
            <img src={image3} className="design_image" />
            <div>
              <h3>Gossamer</h3>
              <p>Brand Identity</p>
            </div>
          </div>
          <div>
            <img src={image1} className="design_image" />
            <div>
              <h3>Gossamer</h3>
              <p>Brand Identity</p>
            </div>
          </div>
          <div>
            <img src={image11} className="design_image" />
            <div>
              <h3>Brown cube</h3>
              <p>Brand Identity</p>
            </div>
          </div>
        </div>
      </section>
      <div className="design_main">
        <Parallax speed={-5}>
          <h3>
            With over half a decade of experience, I have worked with clients in
            fashion, lifestyle, art, and technology, including Mothership.
            Capital X, Mobile Energy and Evajay farms. I am passionate about
            building distinct visual worlds, intuitively capturing the very
            essence of an idea or a message. Off-screen, I enjoy time with my
            family, thinking about space, writing plays, and trying to grow a
            forest on a tiny African balcony.!
          </h3>
          <br />
          <h3> For new project inquiries, please get in touch</h3>
        </Parallax>
      </div>
      <Footer />
    </div>
  );
}

export default Design;
